import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as funnelApi from '@/api/funnel';

export function useCarmaProgression() {
  return useQuery({
    queryKey: ['funnel', 'carma_progression'],
    queryFn: funnelApi.getCarmaProgression,
  });
}

export function useSetUserStage() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      userId,
      stageSlug,
      reason,
    }: {
      userId: string;
      stageSlug: string;
      reason?: string;
    }) => funnelApi.setUserStage(userId, stageSlug, reason),
    onSuccess: (_res, vars) => {
      qc.invalidateQueries({ queryKey: ['funnel'] });
      qc.invalidateQueries({ queryKey: ['tags', 'user', vars.userId] });
      qc.invalidateQueries({ queryKey: ['dashboard', 'students'] });
    },
  });
}

export function useEvaluateUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (userId: string) => funnelApi.evaluateUser(userId),
    onSuccess: (_res, userId) => {
      qc.invalidateQueries({ queryKey: ['funnel'] });
      qc.invalidateQueries({ queryKey: ['tags', 'user', userId] });
    },
  });
}
